import GameListProviderComponent2 from '../../src/components/pages/ProviderPage/components/GameListProviderComponent2';
import GameProviderProviderPageComponent2 from '../../src/components/pages/ProviderPage/components/GameProviderProviderPageComponent2';

function Provider() {
	return (
		<>
			<div className="block my-section">
				<GameProviderProviderPageComponent2 />
				<GameListProviderComponent2 />
			</div>
		</>
	);
}
export default Provider;
